import { ConversionIdEnum } from '#base/core/enums/ConversionIdEnum';
import { TrackingEventEnum } from '#base/core/enums/TrackingEventEnum';

export const useEventTracking = () => {
	const config = useRuntimeConfig();

	const getGoogleAdsEventTrackingId = (conversionId: ConversionIdEnum) => {
		return `${config.public.gtagAdsId}/${conversionId}`;
	};

	const updateConsent = (consents: Gtag.ConsentParams) => {
		if (import.meta.server || typeof gtag === typeof undefined || !gtag) {
			console.warn('consents not updated:', consents);
			return;
		}

		gtag('consent', 'update', consents);

		$fetch('/api/log-cookie-consent', {
			method: 'post',
			body: {
				consents,
			},
		}).then();
	};

	const trackEvent = (event: TrackingEventEnum, eventParams?: object) => {
		if (import.meta.server || typeof gtag === typeof undefined || !gtag) {
			console.warn('not tracked:', event, eventParams);
			return;
		}

		gtag('event', event, {
			...eventParams,
		});
	};

	const trackConversion = (
		{
			conversionId,
			value,
			additionalParams,
		}: {
			conversionId: ConversionIdEnum;
			value?: number;
			additionalParams?: object;
		}
	) => {
		trackEvent(TrackingEventEnum.Conversion, {
			send_to: getGoogleAdsEventTrackingId(conversionId),
			value,
			currency: 'EUR',
			...additionalParams,
		});
	};

	const trackClickToCall = (buttonId: string, value?: number) => {
		trackConversion({
			conversionId: ConversionIdEnum.Call,
			value: value ?? 1,
			additionalParams: {
				name: 'track_click_to_call',
				buttonId,
			},
		});
	};

	const trackEmailClick = (
		buttonId: string,
		value?: number
	) => {
		trackConversion({
			conversionId: ConversionIdEnum.ClickEmail,
			value: value ?? 1,
			additionalParams: {
				name: 'track_email_click',
				buttonId,
			},
		});
	};

	const trackFormAction = (
		formName: string,
		action: string,
		extraInfo?: object
	) => {
		trackEvent(TrackingEventEnum.FormAction, {
			action,
			formName,
			...extraInfo,
		});
	};

	const trackButtonClick = (buttonName: string) => {
		trackEvent(TrackingEventEnum.ButtonClick, {
			buttonName,
		});
	};

	/**
	 * FYSIO HIER EVENT TRACKING
	 */

	const trackBookTherapySession = () => {
		trackConversion({
			conversionId: ConversionIdEnum.BookTherapySession,
			value: 35,
			additionalParams: {
				name: 'track_book_therapy_session',
			},
		});
	};

	/**
	 * FIT HIER EVENT TRACKING
	 */

	const trackLeadFormSgtTrialSubmit = () => {
		trackConversion({
			conversionId: ConversionIdEnum.LeadFormSgtTrial,
			additionalParams: {
				name: 'track_lead_form_sgt_trial_submit',
			},
		});
	};

	const trackLeadFormSgtIntroductionSubmit = () => {
		trackConversion({
			conversionId: ConversionIdEnum.LeadFormSgtIntroduction,
			additionalParams: {
				name: 'track_lead_form_sgt_introduction_submit',
			},
		});
	};

	const trackLeadFormPgtIntroductionSubmit = () => {
		trackConversion({
			conversionId: ConversionIdEnum.LeadFormPgtIntroduction,
			additionalParams: {
				name: 'track_lead_form_pgt_introduction_submit',
			},
		});
	};

	const trackLeadFormPgtInformationSubmit = () => {
		trackConversion({
			conversionId: ConversionIdEnum.LeadFormPgtInformation,
			additionalParams: {
				name: 'track_lead_form_pgt_information_submit',
			},
		});
	};

	const trackLeadFormPtIntroductionSubmit = () => {
		trackConversion({
			conversionId: ConversionIdEnum.LeadFormPtIntroduction,
			additionalParams: {
				name: 'track_lead_form_pt_introduction_submit',
			},
		});
	};

	const trackLeadFormPtInformationSubmit = () => {
		trackConversion({
			conversionId: ConversionIdEnum.LeadFormPtInformation,
			additionalParams: {
				name: 'track_lead_form_pt_information_submit',
			},
		});
	};

	const trackLeadFormUnknownIntroductionSubmit = () => {
		trackConversion({
			conversionId: ConversionIdEnum.LeadFormUnknownIntroduction,
			additionalParams: {
				name: 'track_lead_form_unknown_introduction_submit',
			},
		});
	};

    /**
     * WERK HIER EVENT TRACKING
     */

    const trackLeadFormVacancyApplication = () => {
        trackConversion({
            conversionId: ConversionIdEnum.LeadFormVacancyApplication,
            additionalParams: {
                name: 'track_lead_form_vacancy_application',
            },
        });
    };


	return {
		updateConsent,
		trackEvent,
		trackConversion,
		trackClickToCall,
		trackEmailClick,
		trackFormAction,
		trackButtonClick,

		trackBookTherapySession,

		trackLeadFormSgtTrialSubmit,
		trackLeadFormSgtIntroductionSubmit,
		trackLeadFormPgtIntroductionSubmit,
		trackLeadFormPgtInformationSubmit,
		trackLeadFormPtIntroductionSubmit,
		trackLeadFormPtInformationSubmit,
		trackLeadFormUnknownIntroductionSubmit,

        trackLeadFormVacancyApplication,
	};
};
